export const getParams = () => {
  let search = window.location.search;
  if (!search && window.location.hash.includes('?')) {
    search = window.location.hash.substring(window.location.hash.indexOf('?'));
  }
  return new URLSearchParams(search);
};

export const getPortalCustomerId = () => {
  const params = getParams();
  return (
    params.get('customer_id') ||
    params.get('customerId') ||
    params.get('customer') ||
    params.get('user_id') ||
    params.get('userId') ||
    params.get('identity_id') ||
    params.get('identityId') ||
    params.get('uid')
  );
};

export const isPortalPath = () => window.location.pathname.startsWith('/portal');

export const isCheckoutPath = () => {
  const p = window.location.pathname;
  return p.startsWith('/checkout') || p.startsWith('/hosted-checkout') || p.startsWith('/pay');
};

export const isCustomerSession = () =>
  localStorage.getItem('is_customer_session') === 'true' ||
  localStorage.getItem('subscale_auth_token')?.startsWith('customer_token_');

export const hasPortalLoginToken = () => {
  const params = getParams();
  return Boolean(
    params.get('login_token') ||
    params.get('magic_token') ||
    params.get('token') ||
    params.get('portal_token')
  );
};

export const hasCheckoutIntent = () => {
  const params = getParams();
  return (
    isCheckoutPath() ||
    params.has('checkout_session') ||
    params.has('session_id') ||
    params.has('plan') ||
    params.has('plan_id') ||
    params.has('tier') ||
    params.has('checkout')
  );
};
